import { React, useEffect, useState } from "react";
import {
  RightLayoutContainer,
  PageTitleComp,
  ContentMiddle,
} from "../../styledElements";
import { Button, PageHeader } from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import { useLocation, useNavigate } from "react-router-dom";
import LottieAnimation from "../../../Lottie";
import JobcardPrepare from "../../../Components/IconsFiles/preparing_job_card";
import { uploadOrders } from "../../../Services/uploadServices";

const PreparingUploadOrders = (props) => {
  const history = useNavigate();
  const location = useLocation();

  useEffect(async () => {
    let body = {
      bucket_key: location.state.action,
      format: location.state.format
    }

    await uploadOrders(body)
      .then((response) => {
        if(response?.data?.pos?.length == 0){
          history("../order-records/upload-po", {
            state: { isFileEmpty: true, msg: "NO DATA", fileEmptyKey: "no data"}
          })
        } else{
          history((location.state?.isBalancedQuantityFetched) ? "../order-records/upload-summary" : "../order-records/po-validation", {
            state: { 
              action: response,
              format: location.state.format ,
              fileName: location.state.action,
              isBalancedQuantityFetched: location.state?.isBalancedQuantityFetched,
              checkBoxValue: location.state?.checkBoxValue
            }
          })
      }
      })
      .catch((error) => {
        history("../order-records/upload-po", {
          state: { error: true }
        })
      });
  }, [])

  return (
    <RightLayoutContainer>
      <PageTitleComp style={{ borderBottom: "0" }}>
        <PageHeader
          ghost={false}
          title="Upload PO"
          extra={[
            <Button key="1" className="textTypeBtn textBtnIcon" onClick={() => { history("../order-records/upload-po") }}>
              {" "}
              <Iconmoon
                icon="wrong"
                size={14}
                color="#EA4E2C"
                style={{ marginRight: "8px", top: "1px", position: "relative" }}
              />{" "}
              Cancel Upload
            </Button>,
          ]}
        ></PageHeader>
      </PageTitleComp>
      <ContentMiddle>
        <div className="imageAnimate">
          <div className="imageCover">
            <LottieAnimation lotti={JobcardPrepare} />
            <p>
              We are uploading your orders, <br />
              please wait, it will take less than a minute
            </p>
          </div>
        </div>
      </ContentMiddle>
    </RightLayoutContainer>
  );
};

export default PreparingUploadOrders;
